export default __webpack_public_path__ + "static/media/zombies.3f60c89b.png";